// Bump this string on every UI fix so we can SEE on the device whether the new
// code actually loaded (shown in the sidebar footer + crash screen). If the tag
// you see on the phone doesn't match this, the device is running stale/cached or
// un-redeployed code — not the latest fix.
export const BUILD_TAG = "wms-inv-1 · 03-ago";
